import script from "./material-request.vue?vue&type=script&lang=js&setup=true"
export * from "./material-request.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__